import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/Layout/MainLayout';
import {
  Save,
  ArrowLeft,
  Image as ImageIcon,
  X,
  XCircle,
  Activity,
  FileText,
  Tag
} from 'lucide-react';
import './ProductEditor.css';
import { handleGetApi, handlePostApi } from '../../api/api';
import Cookies from 'js-cookie';

const AddProduct = () => {
  const navigate = useNavigate();
  const token = JSON.parse(Cookies.get('auth_token'));
  const headers = {
    Authorization: token
  }
  // const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    slug: '',
    category_id: '',
    // subcategory_id: '',
    short_description: '',
    description: '',
    badge: '',
    rating: '',
    reviews: 0,
    status: 'Active',
    featured: false,
    is_new_arrival: false
  });
  // const category_id = formData?.category_id || null
    const fetchCategory = async () => {
    const res = await handleGetApi('admin/get/category', headers)
    setCategories(res.data)
  }
  // const fetchSubCategory = async () => {
  //   const res = await handleGetApi(`admin/get/subCategoryById/${category_id}`, headers);
  //   setSubCategories(res.data || [])
  // }
  useEffect(() => {
    fetchCategory();
  }, [])
  // useEffect(()=>{
  //   if(category_id){
  //   fetchSubCategory();
  //   }
  // }, [category_id])
  console.log(formData, 'formData')
  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => {
      const updated = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      };
      if (name === 'name') {
        updated.slug = value
          .toLowerCase()
          .trim()
          .replace(/[^\w\s-]/g, '')
          .replace(/[\s_]+/g, '-')
          .replace(/-+/g, '-')
          .replace(/^-+|-+$/g, '');
      }
      return updated;
    });
  };

  const handleSave = async (e) => {
    e.preventDefault();

    // Validation for mandatory fields
    const requiredFields = {
      name: 'Product Name',
      category_id: 'Category',
      // subcategory_id: 'Sub Category',
      short_description: 'Short Description',
      description: 'Long Description'
    };

    const errors = [];
    Object.entries(requiredFields).forEach(([field, label]) => {
      const value = formData[field];
      if (typeof value === 'string') {
        if (!value.trim()) {
          errors.push(label);
        }
      } else if (!value) {
        errors.push(label);
      }
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      setShowErrorModal(true);
      return;
    }

    const res = await handlePostApi('admin/add/product', formData, headers)
    console.log(res,'res')
    if (res && res.success !== false && res.insertId) {
      navigate(`/products/edit/${res.insertId}`);
    } else {
      if (res && res.success === false) {
        alert(res.message || 'Failed to publish product');
      } else {
        navigate('/products');
      }
    }
  };

  return (
    <MainLayout title='Add New Product'>
      <div className="product-editor-container fade-in">
        <div className="editor-header">
          <button className="back-btn" onClick={() => navigate('/products')}>
            <ArrowLeft size={20} />
            <span>Back to Products</span>
          </button>
          <div className="header-actions">
            <button className="save-product-btn" onClick={handleSave}>
              <Save size={20} />
              <span>Publish Product</span>
            </button>
          </div>
        </div>

        <div className="editor-layout" style={{display:"block"}}>

          <main className="editor-content-area">
            <div className="tab-panel">
                <div className="panel-content">
                  <div className="section-title"><FileText size={20} /> General Information</div>
                  <div className="basic-info-grid">
                    <div className="form-group full-width">
                      <label>Product Name <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="e.g. Modern Velvet Sofa"
                      />
                    </div>
                    <div className="form-group">
                      <label>Slug (URL Key)</label>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        readOnly
                        placeholder="Auto-generated from name"
                      />
                    </div>
                    <div className="form-group">
                      <label>Badge (e.g. New, Bestseller)</label>
                      <input
                        type="text"
                        name="badge"
                        value={formData.badge}
                        onChange={handleInputChange}
                        placeholder="Optional"
                      />
                    </div>
                    <div className="form-group">
                      <label>Category <span style={{ color: 'red' }}>*</span></label>
                      <select name="category_id" value={formData.category_id} onChange={handleInputChange}>
                        <option value="">Select Category</option>
                        {categories?.map((cat) => {
                          return (
                            <option key={cat?.id} value={cat?.id}>{cat?.name}</option>
                          )
                        })}

                      </select>
                    </div>
                    {/* <div className="form-group">
                      <label>Sub Category <span style={{ color: 'red' }}>*</span></label>
                      <select name="subcategory_id" value={formData.subcategory_id} onChange={handleInputChange}>
                        <option value="">Select Sub Category</option>
                        {subCategories && subCategories?.map((cat) => {
                          return (
                            <option key={cat?.id} value={cat?.id}>{cat?.name}</option>
                          )
                        })}
                      </select>
                    </div> */}
                    <div className="form-group">
                      <label>Status</label>
                      <select name="status" value={formData.status} onChange={handleInputChange}>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        <option value="Draft">Draft</option>
                      </select>
                    </div>
                  </div>


                  <div className="section-title"><Tag size={20} /> Descriptions</div>
                  <div className="panel-content" style={{ gap: '20px' }}>
                    <div className="form-group">
                      <label>Short Description <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        name="short_description"
                        value={formData.short_description}
                        onChange={handleInputChange}
                        placeholder="A brief summary..."
                      />
                    </div>
                    <div className="form-group">
                      <label>Long Description <span style={{ color: 'red' }}>*</span></label>
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        rows={6}
                        placeholder="Detailed product details..."
                      />
                    </div>
                  </div>

                  <div className="section-title"><Activity size={20} /> Extras</div>
                  <div className="basic-info-grid">
                    <div className="form-group">
                      <label>Average Rating</label>
                      <input
                        type="number"
                        step="0.1"
                        name="rating"
                        value={formData.rating}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group">
                      <label>Review Count</label>
                      <input
                        type="number"
                        name="reviews"
                        value={formData.reviews}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="featured"
                          checked={formData.featured}
                          onChange={handleInputChange}
                        />
                        <span>Feature this product on homepage</span>
                      </label>
                    </div>
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          name="is_new_arrival"
                          checked={formData.is_new_arrival}
                          onChange={handleInputChange}
                        />
                        <span>New Arrival this product on homepage</span>
                      </label>
                    </div>
                  </div>
                </div>
            </div>
          </main>
        </div>
      </div>

      {showErrorModal && createPortal(
        <div className="error-modal-overlay" onClick={() => setShowErrorModal(false)}>
          <div className="error-modal-content fade-in" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header" style={{ marginBottom: '20px' }}>
              <div className="error-modal-title">
                <XCircle size={28} className="error-icon" />
                <h2>Validation Error</h2>
              </div>
              <button className="close-modal" type="button" onClick={() => setShowErrorModal(false)}>
                <X size={20} />
              </button>
            </div>
            <div className="error-modal-body">
              <p>The following mandatory fields are required:</p>
              <ul className="error-fields-list">
                {validationErrors.map((err, index) => (
                  <li key={index}>
                    <span className="bullet">•</span> {err}
                  </li>
                ))}
              </ul>
            </div>
            <div className="error-modal-actions">
              <button className="dismiss-btn" onClick={() => setShowErrorModal(false)}>
                Okay, got it
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </MainLayout>
  );
};

export default AddProduct;
